import { useState } from "react";
import { toast } from "sonner";
import { Sparkles, Square } from "lucide-react";
import { Button } from "@/components/ui/button";
import { Textarea } from "@/components/ui/textarea";
import { streamAgent, errMsg } from "@/lib/api";

export function useAgentStream() {
  const [output, setOutput] = useState("");
  const [running, setRunning] = useState(false);
  const run = async (agent, body) => {
    setOutput(""); setRunning(true);
    let text = "";
    try { await streamAgent(agent, body, (c) => { text += c; setOutput(text); }); }
    catch (e) { toast.error(errMsg(e)); }
    finally { setRunning(false); }
    return text;
  };
  return { output, setOutput, running, run };
}

export default function AgentRunner({ agent, jobId, placeholder, onResult, compact }) {
  const [input, setInput] = useState("");
  const { output, running, run } = useAgentStream();
  const go = async () => { const t = await run(agent, { input, job_id: jobId || null }); if (t && onResult) onResult(t); };
  return (
    <div className="space-y-3" data-testid={`agent-runner-${agent}`}>
      <Textarea rows={compact ? 2 : 4} value={input} onChange={(e) => setInput(e.target.value)} placeholder={placeholder || "Add context or instructions (optional)"} data-testid="agent-input" />
      <Button onClick={go} disabled={running} data-testid="agent-run-button" className="rounded-full">
        {running ? <><Square className="mr-2 h-4 w-4" />Generating…</> : <><Sparkles className="mr-2 h-4 w-4" />Run agent</>}
      </Button>
      {(output || running) && (
        <div className={`whitespace-pre-wrap rounded-xl border bg-slate-50 p-5 text-sm leading-relaxed ${running ? "stream-caret" : ""}`} data-testid="agent-output">{output}</div>
      )}
    </div>
  );
}
